import { SpinnerIcon } from "../../../icons";

const InlineSpinner = ({ className }: { className?: string }) => (
  <SpinnerIcon className={`animate-spin h-5 w-5 text-gray-500 ${className}`} />
);

export default InlineSpinner;
